import type { GuitarChart } from '../guitarChart.js';
import type { Variant } from '../gameTypes.js';
import { PALETTE_CYAN } from '../builtinPulseMaps/palettes.js';
import { assembleImportedGuitarChart } from './importedGuitarChart.js';
import normalImported from './imported/sky-high-normal.guitar.json' with { type: 'json' };
import hardImported from './imported/sky-high-hard.guitar.json' with { type: 'json' };
import extremeImported from './imported/sky-high-extreme.guitar.json' with { type: 'json' };

export const SKY_HIGH_GUITAR_VARIANTS: Record<Variant, GuitarChart> = assembleImportedGuitarChart({
  baseSlug: 'sky-high',
  baseTitle: "Candyland",
  description: "Tobu's Candyland on -MLG-'s Insane mania chart. Bright 128 BPM NCS electro — Normal thins aggressively, Hard thins lightly, Extreme plays the full stream.",
  difficulty: 4,
  palette: PALETTE_CYAN,
  audioSrc: '/audio/guitar/sky-high.mp3',
  attribution: "\"Candyland\" by Tobu [NCS Release] - https://ncs.io/Candyland",
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
});
